<template>
  <div class="serial-code-create">
    <div class="dialog-content">
      <div class="mb-x2" layout layout-align="space-between-start">
        <el-button type="default" @click="changeTab('serial-code-table')"
          ><i class="mdi mdi-keyboard-backspace"></i>戻る</el-button
        >
      </div>
      <div class="message message-info mb-x2">
        使用済みシリアルコードを入力してください。<br />複数入力する場合、1シリアルコード１行となるよう改行してください。
      </div>
      <!-- シリアルコード-->
      <div class="input-container mb-x2">
        <el-input
          class="body-textarea"
          v-model="serialCode"
          type="textarea"
          placeholder="使用済みシリアルコードを入力"
          :class="{ success: $v.serialCode.required && !$v.serialCode.$invalid }"
        ></el-input>
        <div class="input-invalid-text" v-if="maxSerialCodeError">
          一度にインポートできる件数（10,000件）を超えています。
        </div>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <div layout layout-align="space-between-start">
        <div></div>
        <el-button type="primary" :disabled="disabled" @click="saveSerialCode"
          ><i class="mdi mdi-upload"></i>インポート実行</el-button
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.body-textarea) {
  textarea {
    height: 360px;
  }
}
</style>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'
import { required } from 'vuelidate/lib/validators'

import api from '@/client/core/api'
import { useTwitterInstantwinMessageStore } from '@/client/store/useTwitterInstantwinMessageStore'
import { useTwitterInstantwinSerialCodeStore } from '@/client/store/useTwitterInstantwinSerialCodeStore'

export default defineComponent({
  data() {
    return {
      serialCode: '',
      isSubmit: false,
      isSubmited: false
    }
  },
  computed: {
    ...mapState(useTwitterInstantwinSerialCodeStore, {
      campaignId: state => state.campaignId
    }),
    isFormChanged() {
      return Boolean(this.serialCode.trim())
    },
    maxSerialCodeError() {
      if (!this.serialCode.trim()) {
        return false
      }

      return this.serialCode.trim().split('\n').length > 10000
    },
    disabled() {
      return !this.serialCode || !this.serialCode.trim() || this.maxSerialCodeError || this.isSubmit
    }
  },
  watch: {
    isFormChanged(value) {
      this.$emit('update:isFormChanged', value)
    }
  },
  methods: {
    ...mapActions(useTwitterInstantwinSerialCodeStore, ['fetchSerialCodeList']),
    ...mapActions(useTwitterInstantwinMessageStore, ['fetchInstantwinMessages']),

    /**
     * Change screen
     * @param {string} tab
     */
    changeTab(tab: string) {
      if (this.isFormChanged && !this.isSubmited) {
        const message = '編集内容が保存されていません。ダイアログを閉じてよろしいですか?'
        const confirm = window.confirm(message)

        if (!confirm) {
          return
        }
      }

      this.$emit('change_tab', tab)
    },

    /**
     * Save serial code
     */
    saveSerialCode() {
      if (this.isSubmit) return
      const makeListSerialCodes = this.serialCode
        .replace(/^\s*[\r\n]/gm, '')
        .replace(/^\s+|\s+$/g, '')
        .replace(/@/g, '')
        .split('\n')
      this.postButton({
        campaignId: this.campaignId,
        serialCodes: makeListSerialCodes
      })
    },

    /**
     * 使用済みコードのインポート
     * @param {Object} params 送信データ
     */
    async postButton(params: any) {
      const value = this.serialCode
      const applicants = value
        .replace(/^\s*[\r\n]/gm, '')
        .replace(/^\s+|\s+$/g, '')
        .replace(/@/g, '')
        .split('\n')

      const confirm = window.confirm(
        `${applicants.length}件の使用済みコードをインポートします。\n処理を実行してよろしいですか?\nこの操作は取り消しできません。`
      )

      if (!confirm) {
        return
      }

      this.isSubmit = true

      const response = await api.post(`/twitter_instantwin_serial_codes/used_imports`, params)

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (response.data || response.data === 0) {
        this.$notify({
          title: `${response.data}件の使用済みコードをインポートしました。`,
          message: '',
          customClass: 'success',
          duration: 5000
        })

        this.isSubmited = true

        this.changeTab('serial-code-table')
        await this.fetchInstantwinMessages()
        return
      }

      this.$notify({
        title: '使用済みコードのインポートに失敗しました。',
        message: '恐れ入りますが、時間を置いて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
    }
  },
  validations: {
    serialCode: {
      required
    }
  }
})
</script>
